var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.handle(item.key)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }